<script lang="ts">
  import Tooltip from '../tooltip/Tooltip.svelte';
  import InlineSVG from 'svelte-inline-svg';
  import helpIcon from '../../assets/icons/help.svg';

  export let id: string;
  export let value: number;
  export let min: number;
  export let max: number;
  export let step: number = 1;
  export let required = false;
  export let disabled = false;
  export let tooltipText: string = '';

  $: range = max - min;
</script>

<style lang="postcss">
  label {
    display: grid;
  }

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .labelWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 0.25rem;
    grid-row: 1;
  }

  input:not(:disabled):hover ~ .labelWrapper,
  input:not(:disabled):focus ~ .labelWrapper {
    color: var(--ubilabs-anthracite);
  }

  .disabled {
    opacity: 0.5;
  }

  .value {
    position: relative;
    height: 1.25rem;
    margin: 0 0.5625rem;
  }

  @media (min-width: 768px) {
    .value {
      height: 2rem;
    }
  }

  .value > small {
    position: absolute;
    min-width: 1.25rem;
    transform: translateX(-50%);
    text-align: center;
    white-space: nowrap;
    color: var(--ubilabs-blue);
  }

  @media (min-width: 768px) {
    .value > small {
      padding: 0.25rem 0;
    }
  }

  :global(.diamondTip) {
    margin-left: 0.5rem;
  }
</style>

<label class="grid" class:disabled>
  <input
    {id}
    type="range"
    on:click
    bind:value
    {min}
    {max}
    {step}
    {required}
    {disabled} />

  <div class="labelWrapper">
    <span class="label">
      <slot />
    </span>

    <Tooltip position="bottom" openOnHover={true} class="diamondTip">
      <div slot="trigger">
        <InlineSVG src={helpIcon} />
      </div>
      <div slot="content">
        {tooltipText}
      </div>
    </Tooltip>
  </div>

  <span class="value">
    {#if value != null}
      <small style="left: {(value / range) * 100}%">{value}</small>
    {/if}
  </span>
</label>
